import { ExternalLink, PartyPopper } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { urlDeLaTrivia } from './trivia'

/**
 * Acceso a la trivia semanal desde el menú del área autenticada (goal
 * trivias-de-la-comunidad 5).
 *
 * No es una entrada más de `navigation.ts` a propósito: aquellas son rutas
 * internas (`NavLink`) y esta SALE del portal, así que es un `<a>` con
 * `target="_blank"`. El usuario estaba haciendo algo en su portal; la trivia
 * es una visita, no una migración.
 *
 * Sin `VITE_COMUNIDAD_URL` no se renderiza nada — ni el rótulo de la sección.
 */
export function AccesoTriviaMenu() {
  const { t } = useTranslation()
  const url = urlDeLaTrivia()
  if (!url) return null

  return (
    <div>
      <div className="px-3 pb-2 pt-4 text-[10px] font-semibold uppercase tracking-[0.12em] text-ink-subtle">
        {t('trivia.seccionMenu')}
      </div>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative mx-3 mb-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-[13.5px] font-medium text-[#b7bdc8] transition-colors hover:bg-sidebar-hover hover:text-white"
      >
        <PartyPopper className="h-[18px] w-[18px]" aria-hidden="true" />
        <span className="flex-1">{t('trivia.menu')}</span>
        <ExternalLink
          className="h-3.5 w-3.5 text-ink-subtle transition-colors group-hover:text-white"
          aria-hidden="true"
        />
        {/* La etiqueta accesible dice lo que el icono solo insinúa. */}
        <span className="sr-only">{t('trivia.nuevaPestana')}</span>
      </a>
    </div>
  )
}
